module.exports = __webpack_public_path__ + "img/styles-light.561d3ba2.png";